import PropTypes from 'prop-types';
import styles from './MessageBanner.scss';

export const MessageBanner = ({ text }) => {
  return (
    <div className={styles.banner}>
      {text}
    </div>
  );
};

MessageBanner.propTypes = {
  text: PropTypes.string.isRequired,
};

MessageBanner.defaultProps = {
};
